import { render, staticRenderFns } from "./userctrl.vue?vue&type=template&id=f55429e6"
import script from "./userctrl.vue?vue&type=script&lang=js"
export * from "./userctrl.vue?vue&type=script&lang=js"
import style0 from "./userctrl.vue?vue&type=style&index=0&id=f55429e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports